import { Model } from '@/models/Model';
export class ContractHour extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'ContractHour';
        this.$endpoint = '/contract-hours';
        this.$fillable = ['starts_at', 'ends_at', 'user'];
    }
    get backgroundEvent() {
        const parsedEvent = {
            start: this.starts_at || '',
            end: this.ends_at || '',
            rendering: 'background',
        };
        return parsedEvent;
    }
    getFilterLabel() {
        return this.id || '';
    }
    resolvePrimaryKey() {
        return '';
    }
}
